import React, { useEffect, useRef, useState } from "react";
import Resizer from "react-image-file-resizer";
import {
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
} from "../Component";

// import Webcam from "react-webcam";
import axios from "axios";
import { Camera } from "react-camera-pro";
import { useFieldArray, useFormContext } from "react-hook-form";
import Zoom from "react-medium-image-zoom";
import { toast } from "react-toastify";
import { GET } from "../../helper/api";
const BillPicture = ({
  disabledUpload,
  onExtractWeight,
  extractingSrc,
}) => {
  const refImg = useRef(null);
  const refCamera = useRef(null);
  const [cameraChoosed, setCameraChoosed] = useState("");
  const [cameraList, setCameraList] = useState([]);
  const [videoStream, setVideoStream] = useState();

  const { register, control } = useFormContext();

  const { fields: billPictures, remove: removePicture, append: appendPicture } = useFieldArray({
    control: control,
    name: 'billPictures',
  })

  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((mediaStream) => {
        setVideoStream(mediaStream);
        navigator.mediaDevices
          .enumerateDevices()
          .then((handleDevices) => {
            setCameraList(handleDevices.filter((e) => e.kind === "videoinput"));
          })
          .catch((err) => {
            toast.error("Can't load default camera");
          });
      })
      .catch((err) => {
        toast.error("Can't load camera");
      });
  }, []);

  useEffect(() => {
    return () => {
      stopVideo();
    };
  }, [videoStream]);

  const stopVideo = () => {
    if (videoStream) {
      videoStream.getTracks().forEach((track) => {
        if (track.readyState === "live") {
          track.stop();
        }
      });
    }
  };

  const uploadPicture = async (e) => {
    e.preventDefault();
    if (e.target.files.length === 0) {
      return;
    }
    const files = Array.from(e.target.files);
    let isValid = true;
    files.forEach((file) => {
      if (
        !["jpeg", "jpg", "png"].includes(
          file.name.substr(file.name.lastIndexOf(".") + 1)
        )
      ) {
        isValid = false;
      }
    });
    if (!isValid) {
      toast.error("Vui lòng chọn file: jpeg, jpg, png");
      return;
    }
    const data = await Promise.all(files.map(item => readFileAsDataURL(item)));

    data.forEach((dataUrl) => {
      return uploadPic({ dataUrl })
    });
  };

  const onTakePicture = (value) => {
    uploadPic({ dataUrl: value });
  };

  const uploadPic = async ({ dataUrl }) => {
    try {
      const blob = convertDataUrlToBlob(await resizeFile(dataUrl));

      const { data: { presignedUrl, mediaUrl } } = await GET("/media/presigned-url", {
        // type: blob.type
      }, true);
      await axios.put(presignedUrl, blob, {
        headers: {
          'Content-Type': blob.type
        }
      });
      appendPicture({ src: mediaUrl });
    } catch (error) {

      toast.error(
        error?.response?.data?.exception?.message ||
        error?.response?.data?.error ||
        "Có lỗi xảy ra! Vui lòng thử lại."
      );
    } finally {
      refImg.current.value = null;
    }
  };

  const convertDataUrlToBlob = (dataUrl) => {
    const byteString = atob(dataUrl.split(",")[1]);
    const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: mimeString });
    return blob;
  };

  const readFileAsDataURL = async (file) => {
    return await new Promise((resolve) => {
      let fileReader = new FileReader();
      fileReader.onload = (e) => resolve(fileReader.result);
      fileReader.readAsDataURL(file);
    });
  }

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        convertDataUrlToBlob(file),
        800,
        800,
        "JPEG",
        70,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });

  return (
    <div>
      <BlockHead>
        <BlockHeadContent>
          <BlockTitle tag="h5" className={`text-primary`}>Hình ảnh</BlockTitle>
        </BlockHeadContent>
      </BlockHead>
      <Row>
        {disabledUpload ? (
          <></>
        ) : (
          <Col xs="12" sm="12" md="4" className={'h-100'}>
            <div style={{ minWidth: 240, maxWidth: 320, width: '100%' }}>
              <select
                placeholder="Vui lòng chọn video"
                className="form-control mb-2"
                value={cameraChoosed}
                onChange={(e) => setCameraChoosed(e.target.value)}
              >
                {cameraList.map((e, key) => (
                  <option key={key} value={e.deviceId}>
                    {e.label}
                  </option>
                ))}
              </select>
            </div>

            <div style={{
              minWidth: 240,
              minHeight: 180,
              maxWidth: 320,
              maxHeight: 240,
              height: '100%',
              width: '100%',
              display: 'block',
              position: 'relative'
            }}>
              <Camera
                facingMode={'environment'}
                ref={refCamera}
                {...(cameraChoosed ? { videoSourceDeviceId: cameraChoosed } : {})}
              />
            </div>
            <div className="w-100 mt-2">
              <button
                type="button"
                className="btn btn-primary mr-1"
                onClick={() => onTakePicture(refCamera.current.takePhoto())}
              >
                Chụp màn hình
              </button>
              <button
                type="button"
                className="btn btn-primary ml-1"
                onClick={() => refImg.current.click()}
              >
                Tải ảnh lên
              </button>
              <input
                ref={refImg}
                onChange={(e) => uploadPicture(e)}
                type="file"
                className="d-none"
                multiple="multiple"
              />
            </div>
          </Col>
        )}

        <Col xs="12" sm="12" md="8">
          <Row>
            {billPictures.map((picture, idx) => (
              <Col
                key={idx}
                xs="6"
                sm="6"
                md="3"
                className="position-relative pt-1 pb-1"
              >
                <Zoom>
                  <input
                    alt=""
                    type="image"
                    src={picture.src}
                    defaultValue={picture.src}
                    ref={register()}
                    name={`billPictures.${idx}.src`}
                    className="w-100 border border-info"
                  />
                </Zoom>
                <>
                  <Button
                    type="button"
                    onClick={() => {
                      removePicture(idx);
                    }}
                    className="position-absolute btn-ghost-danger"
                    style={{ left: 0, top: 0 }}
                  >
                    <Icon name="trash" className={"text-danger"}></Icon>
                  </Button>
                </>
                {onExtractWeight && (
                  <div className="text-center mt-1">
                    <Button
                      type="button"
                      size="sm"
                      color="primary"
                      disabled={extractingSrc === picture.src}
                      onClick={() => onExtractWeight(picture.src)}
                    >
                      {extractingSrc === picture.src
                        ? "Đang xuất..."
                        : "Xuất KL từ ảnh"}
                    </Button>
                  </div>
                )}
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default BillPicture;
